<template>
  <!-- 库存预警规则管理 -->
  <div class="warn-rule-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="商品名称/规则名称" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
            <template #prefix>状态</template>
            <el-option label="启用" :value="1"/>
            <el-option label="停用" :value="0"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="openDialog()">新增预警规则</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="warnRuleList">
          <yq-table-column label="商品(SKU)" prop="productName" min-width="200rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="仓库" prop="warehouseName" min-width="180rem">
            <template v-slot="{row}">
              <el-tag v-if="!row.warehouseId" size="small" type="primary">全部仓库</el-tag>
              <span v-else>{{row.warehouseName}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="下限阈值" prop="minQty" width="120rem" align="center">
            <template v-slot="{row}">
              <span v-if="row.minQty != null">{{row.minQty}}</span>
              <span v-else class="muted">—</span>
            </template>
          </yq-table-column>
          <yq-table-column label="上限阈值" prop="maxQty" width="120rem" align="center">
            <template v-slot="{row}">
              <span v-if="row.maxQty != null">{{row.maxQty}}</span>
              <span v-else class="muted">—</span>
            </template>
          </yq-table-column>
          <yq-table-column label="计量单位" prop="unitName" width="120rem" align="center"/>
          <yq-table-column label="状态" prop="status" width="120rem" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="row.status === 1 ? 'success' : 'info'">{{row.status === 1 ? '启用' : '停用'}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="备注" prop="remark" min-width="180rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button type="write" @click="openDialog(row)">编辑</table-button>
                <table-button type="write" @click="updateStatus(row)">{{row.status === 1 ? '停用' : '启用'}}</table-button>
                <table-button type="delete" el-type="danger" message="是否确认删除该预警规则" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="showDialog" :title="dialogData.id ? '编辑预警规则' : '新增预警规则'" dialog-width="2" :close-on-click-modal="false">
      <form-items :data="dialogData" :columns="2" label-width="2.4rem" icon-width="0" ref="dialogForm">
        <form-item label="商品(SKU)" :required="true" name="productId" error-message="请选择商品">
          <product-select v-model="dialogData.productId" placeholder="请选择要预警的商品" @change="selectProduct"/>
        </form-item>
        <form-item label="仓库">
          <el-select v-model="dialogData.warehouseId" clearable placeholder="不选表示全部仓库">
            <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
          </el-select>
        </form-item>
        <form-item label="下限阈值">
          <el-input-number v-model="dialogData.minQty" :min="0" placeholder="库存低于该值预警" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="上限阈值">
          <el-input-number v-model="dialogData.maxQty" :min="0" placeholder="库存高于该值预警" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="状态">
          <el-select v-model="dialogData.status">
            <el-option label="启用" :value="1"/>
            <el-option label="停用" :value="0"/>
          </el-select>
        </form-item>
        <form-item label="备注" :show-block="true">
          <el-input type="textarea" v-model="dialogData.remark" placeholder="备注信息"/>
        </form-item>
      </form-items>
      <template #footer>
        <form-page :show-shadow="false" :show-border="false" :show-page="false">
          <template #left>
            <div class="tip-text">下限/上限可同时设置，也可只设置其一；阈值按基本单位计算。</div>
          </template>
          <page-button @click="showDialog = false">取消</page-button>
          <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
        </form-page>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import ProductSelect from "@/components/h5/product/ProductSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import warnRuleApi from "@/api/normal/stock/warnRuleApi";
import warehouseApi from "@/api/normal/stock/warehouseApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "WarnRuleList",
  components: {
    FormItems, FormItem, DialogTable, ProductSelectTable, ProductSelect,
    YqTableColumn, TableButtonGroup, TableButton,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {pageNumber: 1},
      dataList: [],
      warehouseOptions: [],
      ruleProducts: [],
      showDialog: false,
      dialogData: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.init();
      this.resetSearch();
    }
  },
  methods: {
    async init() {
      const {records} = await warehouseApi.queryList({pageNumber: 1, pageSize: 100});
      this.warehouseOptions = records || [];
    },
    async queryList() {
      const {records, totalCount} = await warnRuleApi.queryList(this.searchInfo);
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    openDialog(row) {
      this.ruleProducts = [];
      if (row) {
        this.dialogData = JSON.parse(JSON.stringify(row));
        // 商品回填
        this.ruleProducts = [{
          skuId: row.skuId || row.productId,
          productId: row.productId,
          productName: row.productName || "",
        }];
      } else {
        this.dialogData = {productId: "", skuId: "", warehouseId: "", minQty: null, maxQty: null, status: 1, remark: ""};
      }
      this.showDialog = true;
    },
    // 单选商品（主商品选择/行选择）
    selectProduct(data) {
      this.dialogData.skuId = data.id;
      this.dialogData.productId = data.parentId || data.id;
    },
    async saveData() {
      if (!this.$refs.dialogForm.validCheck()) { // 数据验证不通过
        return;
      }
      await warnRuleApi.save(this.dialogData);
      this.showDialog = false;
      this.resetSearch();
    },
    async updateStatus(row) {
      const status = row.status === 1 ? 0 : 1;
      await warnRuleApi.updateStatus(row.id, status);
      this.$message.success(status === 1 ? "已启用" : "已停用");
      this.resetSearch();
    },
    async toDelete(row) {
      await warnRuleApi.delete(row.id);
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.warn-rule-list {
  height: 100%;
  .tip-text {
    font-size: 12px;
    color: var(--yq-font-color-tips);
    //color: var(--el-color-primary-light-9);
  }
  .muted { color: var(--yq-font-color-desc); font-size: 12px; }
}
</style>
